export default __webpack_public_path__ + "static/media/user-icon.54d4ea9b.svg";